import { AdminNotificationType } from '../../../models/admin-notification/dto/admin-notification-feed.dto';
import { translate } from '../../../i18n';

export function getTypeColor(type: AdminNotificationType): string {
  switch (type) {
    case AdminNotificationType.courtBookingCreated:
      return 'green.400';
    case AdminNotificationType.courtBookingCanceled:
      return 'orange.400';
    case AdminNotificationType.paymentFailed:
      return 'red.400';
    default:
      return 'gray.400';
  }
}

export function getTypeColorScheme(type: AdminNotificationType): string {
  switch (type) {
    case AdminNotificationType.courtBookingCreated:
      return 'green';
    case AdminNotificationType.courtBookingCanceled:
      return 'orange';
    case AdminNotificationType.paymentFailed:
      return 'red';
    default:
      return 'gray';
  }
}

export function getTypeLabel(type: AdminNotificationType): string {
  const key = `admin_notifications.type_${type}` as any;
  const translated = translate(key);
  // translate() returns undefined for missing keys, or the key itself
  if (translated && translated !== key) return translated;
  return type;
}

export function formatRelativeTime(dateStr: string): string {
  const now = Date.now();
  const date = new Date(dateStr).getTime();
  if (isNaN(date)) return '';
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 1) return translate('admin_notifications.just_now' as any);
  if (diffMin < 60) return `${diffMin}m`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h`;
  const diffDays = Math.floor(diffHr / 24);
  return `${diffDays}d`;
}
